import ScrollDirective from './scroll.directive';
import scrollFactory from './scroll.factory';

const ertScrollModule = angular.module('app.common.ertScroll', [])
	.factory('scrollService', scrollFactory)
	.directive('ertScroll', () => new ScrollDirective())
	.name;

export default ertScrollModule;
